const baseURL = `${process.env.VUE_APP_SERVER_URL}/DadosSaude`;

export async function ListarInsightsSaude({ vinculo }: { vinculo?: string }) {
  return globalThis.window.$axios
    .get({
      url: `${baseURL}/ListarInsightsSaude`,
      query: {
        vinculo
      }
    })
    .then((resp: any) => resp.data)
    .catch((error: any) => {
      globalThis.window.$log?.error?.("ListarInsightsSaude", error?.message || error);
      throw error;
    });
}

export async function ObterInsightSaude({ vinculo, id }: { vinculo?: string; id: string }) {
  return globalThis.window.$axios
    .get({
      url: `${baseURL}/ObterInsightSaude`,
      query: {
        vinculo,
        id
      }
    })
    .then((resp: any) => resp.data)
    .catch((error: any) => {
      globalThis.window.$log?.error?.("ObterInsightSaude", error?.message || error);
      throw error;
    });
}
